import {
  AddTagToCandidateDocument,
  AddTagToCandidateMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useAddTagToCandidate = () => {
  const [createTag, { loading }] = useMutation(AddTagToCandidateDocument, {
    extractorFn: (data) => data.atsMutations.addTagAtsCandidate,
  })

  return {
    loading,
    addTag(variables: AddTagToCandidateMutationVariables) {
      return createTag({
        variables,
      })
    },
  }
}
